import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import { connect, Dispatch } from 'react-redux';

import { IEventMonth } from '@adage/ace-calendar';

import { IWACEvent } from '../classes/event';
import { ICalendarReduxState } from "../classes/index";
import { clearFilterSelections } from "../redux/actions/index";

interface EmptyEventsExternalProps {
}

interface StateToProps {
    emptyFiltersTextHtml: string;
}

interface EmptyEventsDispatchToProps {
    clearFilters: () => any;
}


type EmptyEventsProps = EmptyEventsExternalProps & StateToProps & EmptyEventsDispatchToProps;

const emptyEvents: React.SFC<EmptyEventsProps> = (props) => {
    return (
        <div className="cal-no-events">
            <div className="cal-no-events-inner">
                <div dangerouslySetInnerHTML={{ __html: props.emptyFiltersTextHtml }} className="cal-no-events-msg rich-text"></div>
                <p className="cal-no-events-msg">Try to <button className="un-button cal-clear-filters" onClick={props.clearFilters}>clear filters</button>.</p>
            </div>
        </div>
    );
}


function mapStateToProps(state: ICalendarReduxState) {
    return {
        emptyFiltersTextHtml: state.calendarTextModel.text.emptyEventsMessage
    }
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>) {
    return {
        clearFilters: () => dispatch(clearFilterSelections())
    }
}


export default connect<StateToProps, EmptyEventsDispatchToProps>(mapStateToProps, mapDispatchToProps)(emptyEvents);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/views/empty-events.tsx